import * as msal from "@azure/msal-browser";
import { getLangCode } from "./getLangCode";

export function msalConfig(): msal.Configuration {
  const langCode = getLangCode();
  // TODO: to be updated for all locales during global sdc launch, Adding only to en-us locale, dev and prod as PPE does not support new sdc cdn urls
  const redirectUri = 
  (langCode === "en-us" && process.env.REACT_APP_ANALYTICS_ENV !== "ppe") ? 
    (process.env.REACT_APP_ANALYTICS_ENV === "dev" 
    /**  Comment above line and uncomment below line to run application in local to support multitenancy */
    // (process.env.REACT_APP_ANALYTICS_ENV === "local"
      ? `https://isv-adv-dev-eastus-app.azurewebsites.net/${langCode}/software-development-companies/app-advisor/guidance/my-results`
      : `${process.env.REACT_APP_REDIRECT_URI_SDC}/my-results`)
  :
    (process.env.REACT_APP_ANALYTICS_ENV === "dev"
      ? `https://isv-adv-dev-eastus-app.azurewebsites.net/${langCode}/isv/marketplace-app-advisor/my-results`
      : process.env.REACT_APP_REDIRECT_URI);

  return {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID as string,
      // authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47/",
      // Comment below and uncomment above line to run single tenant mode with Dev/PPE app id in local
      authority: "https://login.microsoftonline.com/common/",
      //redirectUri: "http://localhost:3000/", // uncomment this to run in local and comment below one
      redirectUri: redirectUri,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
// productIngestion scope for draft offer creation
export const productIngestionTokenRequest = {
  scopes :["https://graph.microsoft.com/.default"]
}
